import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDocuments } from 'contexts/documents'
import { clamp } from 'utilities/math'
import { cls } from 'utilities/dom'
import { Wrap, LoadingContainer } from './s'
import SlimDocument from './document-slim'
import Loader from 'components/loader'
import { Ghost } from 'components/button'
import { getActionsArray } from 'widgets/context-menu'
import { SkeletonListRow, SkeletonCell, SkeletonCategory, SkeletonStrings, SkeletonAvatars } from 'components/skeleton'

const SlimDocuments = ({ actions = [], className }) => {
    const {
        dokuments,
        intersecter,
        loading,
        paging = {},
        fetch,
        fetching,
        autoFetch,
        hasFetched,
        flash,
        clearFlash
    } = useDocuments()

    const [skeletonLength, setSkeletonLength] = useState(5)

    const hasActions = !!getActionsArray(actions).length
    const { hasNextPage } = paging

    useEffect(() => {
        if(hasFetched) {
            setSkeletonLength(clamp(dokuments.length, 1, 10))
        }
    }, [hasFetched, dokuments?.length])

    className = cls([
        className,
        'slim'
    ])

    return (
        <Wrap className={className}>
            {(!!fetching && !hasFetched) && [...Array(skeletonLength).keys()].map(index => (
                <SkeletonListRow
                    columns={3}
                    hasActions={!!hasActions}
                    key={`list:documents:skeleton:${index}`}>
                    <SkeletonCell>
                        <SkeletonCategory size={24} showSecondLine={index % 2 === 0} />
                    </SkeletonCell>
                    <SkeletonCell>
                        <SkeletonStrings size={20} count={2} />
                    </SkeletonCell>
                    <SkeletonCell>
                        {index % 3 === 0 && (
                            <SkeletonAvatars size={32} />
                        )}
                        {index % 3 !== 0 && (
                            <SkeletonStrings size={20} />
                        )}
                    </SkeletonCell>
                </SkeletonListRow>
            ))}
            {!dokuments.length && (
                <div>No documents to sign.</div> // TODO
            )}
            {dokuments.map((dokument, index) => {
                const last = index + 1 === dokuments.length

                return (
                    <SlimDocument
                        dokument={dokument}
                        actions={actions}
                        {...(last ? { ref: intersecter } : null)}
                        flash={flash?.current === dokument ? clearFlash : null}
                        key={`document:slim:${dokument.id}`} />
                )
            })}
            {!!hasNextPage && (
                <LoadingContainer>
                    {(!loading && !autoFetch) && (
                        <Ghost className="constructive" onClick={fetch}>
                            <FormattedMessage
                                id="action_load_more"
                                defaultMessage="Load more…"
                            />
                        </Ghost>
                    )}
                    {!!loading && <Loader />}
                </LoadingContainer>
            )}
        </Wrap>
    )
}

export default SlimDocuments